import { useSelector } from 'react-redux';
import { keepPreviousData } from '@tanstack/react-query';

import { Environment, AppID } from '@playq/octopus-common';
import { GenericFailure } from '@playq/services-shared';
import { IdentityId, IdentificationResponse } from '@playq/services-fingerprint';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { appToolkit } from '/store';

import { playerLookupKeys } from './constants';

export const useLoginWithPrimaryIdUser = (
  { identityId, env }: { identityId: IdentityId; env: Environment },
  options?: IUseQueryOptionsExtended<IdentificationResponse | undefined, GenericFailure | Error>
) => {
  const appID: AppID | undefined = useSelector(appToolkit.selectors.appID);

  return useEitherQuery(
    playerLookupKeys.loginWithPrimaryId(identityId, env, appID),
    () => {
      if (appID) {
        return services2.fingerprintLookupService.loginWithPrimaryIdAsUser(appID, identityId, env);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );
};
